import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from '../../util/Api';

import {
  CLEAR_ATA_PROPS,
  CREATE_ASSET_TRANSFER_ADVICE_SUCCESS,
  FETCH_ASSET_TRANSFER_ADVICE_SUCCESS,
  FETCH_ASSETS_BY_QUERY_SUCCESS,
  FETCH_ATA_NO_SUCCESS,
  FETCH_METER_UNIT_SUCCESS,
  GET_ASSET_TRANSFER_ADVICE_SUCCESS,
  GET_ATA_COUNT_START,
  GET_ATA_COUNT_SUCCESS,
  SAVE_ASSET_TRANSFER_ADVICE_QUERY,
} from '../../constants/ActionTypes';

import axios from 'util/Api';
import { fetchError, fetchStart, fetchSuccess } from './Common';
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_ASSET_TRANSFER_ADVICE_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ASSET_TRANSFER_ADVICE_QUERY,
    query,
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_ASSET_TRANSFER_ADVICE_SUCCESS,
    data,
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_TRANSFER_ADVICE_SUCCESS,
    data,
  };
};

export const clearProps = () => {
  return {
    type: CLEAR_ATA_PROPS,
  }
}

export const fetchAssetsByQuerySuccess = ({ data }) => {
  return {
    type: FETCH_ASSETS_BY_QUERY_SUCCESS,
    data,
  };
};

export const fetchUnitSuccess = (data) => {
  return {
    type: FETCH_METER_UNIT_SUCCESS,
    data
  };
};

// export const fetchAllMeterUnitSuccess = (data) => {
//   return {
//     type: FETCH_ALL_METER_UNIT_SUCCESS,
//     data
//   };
// };

export const fetchAtaNoSuccess = ({ data }) => {
  return {
    type: FETCH_ATA_NO_SUCCESS,
    data,
  };
};

export const findParentAsset = async (id) => {
  const response = await axios.get(`/asset/parent/${id}`);
  return response.data;
}

export const findSubAssets = async (id) => {
  const response = await axios.get(`/asset/subAssets/${id}`);
  return response.data;
}

export const fetchAssetsByQuery = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    let query = '';
    Object.entries(data).forEach(([key, value], index) => {
      if (Object.keys(data).length - 1 === index) {
        query += `${key}=${value}`
      } else {
        query += `${key}=${value}&`
      }
    });
    try {
      const response = await axios.get(`/asset/getAssetByQuery?${query}`);
      dispatch(fetchSuccess());
      dispatch(fetchAssetsByQuerySuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchAtaNo = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get('/asset-transfer-advice/getAtaNo');
      dispatch(fetchSuccess());
      dispatch(fetchAtaNoSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchMeterUnit = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    let query = '';
    Object.entries(data).forEach(([key, value], index) => {
      if (Object.keys(data).length - 1 === index) {
        query += `${key}=${value}`
      } else {
        query += `${key}=${value}&`
      }
    });
    try {
      const response = await axios.get(`/interval/unit?${query}`);
      dispatch(fetchSuccess());
      dispatch(fetchUnitSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const fetchAllMeterUnit = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/interval/allMeterUnitAta`);
      dispatch(fetchSuccess());
      dispatch(fetchUnitSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { assetTransferAdvice } = store.getState();
      const { query } = assetTransferAdvice;
      const response = await axios.get(`/asset-transfer-advice?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { assetTransferAdvice } = store.getState();
      const { query } = assetTransferAdvice;
      const response = await axios.get(`/asset-transfer-advice/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      payload.documents && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = { ...item };
        delete data.file;
        documentData.push(data);
      });

      formData.append('documentData', JSON.stringify(documentData));

      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return;
        }

        if (key === 'from' || key === 'to' || key === 'approvedBy' || key === 'preparedBy' || key === 'readings' || key === 'dependentAssets') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }

        if (key === 'owner') {
          if (!payload[key]) {
            return;
          }
        }
        formData.append(key, payload[key]);
      });

      const response = await axios.post(`/asset-transfer-advice`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      dispatch(fetchSuccess());

      dispatch(createResourceSuccess({ data: response.data }));
      history.push('/asset-transfer-advice');
      dispatch(getResource());

    } catch (error) {
      console.log('Error****:', error);
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
    }
  };
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {

      let formData = new FormData();

      const documentData = [];
      const documentIds = [];
      payload.documents.map((item, index) => {
        if (!item.file.path) {
          formData.append('files', item.file);
          let data = { ...item };
          delete data.file;
          documentData.push(data);
        } else {
          documentIds.push(item._id);
        }
      });

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('documentIds', JSON.stringify(documentIds));

      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return;
        }

        if (key === 'from' || key === 'to' || key === 'approvedBy' || key === 'preparedBy' || key === 'readings' || key === 'dependentAssets') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }

        formData.append(key, payload[key]);
      });
      await axios.put(`/asset-transfer-advice/${id}`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      dispatch(fetchSuccess());
      history.push('/asset-transfer-advice');
      dispatch(getResource());
    } catch (error) {
      console.log('Error****:', error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/asset-transfer-advice/${id}`);
      dispatch(fetchSuccess());


      if (response && response.data && response.data.assets && response.data.assets.length) {
        for (let i = 0; i < response.data.assets.length; i++) {
          let obj = response.data.assets[i];
          if (response.data.readings && response.data.readings.length) {
            for (let j = 0; j < response.data.readings.length; j++) {
              if (obj._id === response.data.readings[j].asset._id) {
                obj.meter = response.data.readings[j].meter || '';
                obj.meterUnit = response.data.readings[j].meterUnit || '';
              }
            }
          }
        }
      }

      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/asset-transfer-advice/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};


export const getATACount = (status = 'Open', payload = {}) => {
  return async dispatch => {
    dispatch(getATACountStart());
    try {
      const response = await axios.post(`/asset-transfer-advice/ata-count/${status}`, payload);
      // console.log(response);
      dispatch(getATACountOk(response.data[0] || {}));
    } catch (error) {
      dispatch(getATACountOk({ totalAssets: 0, count: 0 }));
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getATACountOk = ({ totalAssets, count }) => {
  return {
    type: GET_ATA_COUNT_SUCCESS,
    totalAssets,
    count
  };
};

export const getATACountStart = () => {
  return {
    type: GET_ATA_COUNT_START
  };
};

export const ataBulkImport = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      formData.append('files', payload.file);
      const response = await axios.post(`/common/import-ata`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      const { data } = response;
      console.log(JSON.stringify(data, null, 1));
      if (data && data.length) {
        const atasCreated = data
          .filter(item => item && item.ata)
          .map(item => `ATA-${item.ata}`)
          .join(', ');
        const message = `ATAs created: ${atasCreated}`;
        message.success(message);
      }
      downloadJSONFile({
        data: JSON.stringify(data, null, 1),
        fileName: 'ata-import' + new Date().getTime() + '.json',
        fileType: 'text/json',
      });
      dispatch(fetchSuccess());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

const downloadJSONFile = ({ data, fileName, fileType }) => {
  const blob = new Blob([data], { type: fileType });
  const a = document.createElement('a');
  a.download = fileName;
  a.href = window.URL.createObjectURL(blob);
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  a.dispatchEvent(clickEvt);
  a.remove()
};
